import {
  HorizontalSectionInfo,
  VerticalSectionInfo,
} from '../../core/types/ui/placement';

export interface TopSection {
  menuBar: HorizontalSectionInfo;
  toolBar: HorizontalSectionInfo;
  formulaBar: HorizontalSectionInfo;
}

export interface BottomSection {
  bottomBar: HorizontalSectionInfo;
  // formulaBar: HorizontalSectionInfo;
}

export interface RightSection {
  sideWindow: VerticalSectionInfo;
}

export interface LeftSection {}

export interface SectionsState {
  fullScreen: boolean;
  topSection: TopSection;
  rightSection: RightSection;
  bottomSection: BottomSection;
  leftSection: LeftSection;
}

export enum Section {
  TopSection = "topSection",
  RightSection = "rightSection",
  BottomSection = "bottomSection",
  LeftSection ="leftSection",
  FullScreen = "fullScreen"
}